import { render, staticRenderFns } from "./FlameIcon.vue?vue&type=template&id=0e07a474&scoped=true"
import script from "./FlameIcon.vue?vue&type=script&lang=js"
export * from "./FlameIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e07a474",
  null
  
)

export default component.exports